module.exports = __webpack_public_path__ + "img/Grupo 1400@2x.c6244b2a.png";